// src/components/template/RegistrationSuccess.js
import React, {useEffect} from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useLocation } from 'react-router-dom';

const anonymizeEmail = (email) => {
    if (!email) return '';
    const [localPart, domain] = email.split('@');

    const anonymizePart = (part) => {
        if (part.length <= 2) {
            return part;
        }
        return `${part[0]}${'*'.repeat(part.length - 2)}${part[part.length - 1]}`;
    };

    const anonymizedLocalPart = anonymizePart(localPart);
    const anonymizedDomain = anonymizePart(domain);

    return `${anonymizedLocalPart}@${anonymizedDomain}`;
};

const RegistrationSuccess = ({setShowNav}) => {
    const location = useLocation();
    const email = location.state?.email;
    const anonymizedEmail = anonymizeEmail(email);
    useEffect(() => {
        setShowNav(false);
    }, []);

    return (
        <Container maxWidth="sm" sx={{ textAlign: 'center', mt: '-90px', height: '100vh', display: 'flex',
            alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 5}}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '130px',
                    textDecoration: 'none',
                    textAlign: 'center',
                    cursor: 'pointer',
                }}
            >
                <img alt={'Logo OHS'} src={'/assets/icon/logo-ohs.png'} role="img" />
            </Box>
            <Box sx={{ padding: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: 'white', borderRadius: '5px' }}>
                <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'green', mb: 2 }} />
                <Typography variant="h4" sx={{ mb: 2 }}>
                    Inscription réussie!
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                    Merci pour votre inscription. Veuillez vérifier votre email ({anonymizedEmail}) pour finaliser l'inscription.
                </Typography>
            </Box>
        </Container>
    );
};

export default RegistrationSuccess;